import { Form, Select } from "antd";
import useAdminClients from "@/hooks/useAdminClients";
import { useTranslation } from "react-i18next";

interface AdminClientsProps {
  chosenAdminClients: string[];
  setChosenAdminClients: (clients: string[]) => void;
}

const { Option } = Select;

const AdminClients = ({
  chosenAdminClients,
  setChosenAdminClients,
}: AdminClientsProps) => {
  const { t } = useTranslation();
  const { adminClients, getAdminClientsLoading } = useAdminClients({});

  return (
    <Form.Item name="adminClients" label={t("Контрагент")}>
      <Select
        style={{ width: 200 }}
        mode="multiple"
        loading={getAdminClientsLoading}
        listHeight={1000}
        allowClear
        value={chosenAdminClients}
        onChange={setChosenAdminClients}
      >
        {adminClients?.map((adminClient) => (
          <Option key={adminClient.clientUUID} value={adminClient.clientUUID}>
            {adminClient.name || " "}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default AdminClients;
